import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Row, Col, message } from "antd";
import { useAuthContext } from "@/components/auth/AuthProvider";
import VerifyCode from "@/components/auth/VerifyCode";
import DatetimeLabel from "./DatetimeLabel";
import AnnouncementCard from "./AnnouncementCard";
import PublicationCard from "./PublicationCard";
import ExchangeCard from "./ExchangeCard";
import MessageCard from "./MessageCard";
import SubmitMessageCard from "./SubmitMessageCard";
import styles from "./index.module.less";

function WelcomeLayout() {
  const auth = useAuthContext();
  const [time, setTime] = useState(Date.now());
  const dispatch = useDispatch();
  const operate = useCallback(() => {
    const now = Date.now();
    if (now - time > 3600000) {
      message.warning("登录已超时，请重新登录");
      dispatch.user.logout();
    } else if (Date.now() - time > 1000) {
      setTime(Date.now());
    }
  }, [time, setTime, dispatch]);

  if (!auth.is_original) {
    return <VerifyCode phone={auth.phone} />;
  }

  return (
    <div
      className={styles.welcomeLayout}
      onMouseMove={(e) => {
        operate();
      }}
    >
      <div className="welcome-header-container">
        <div className="welcome-header">
          <div className="welcome-header-title">
            甘肃省政务信息报送系统
            <span className="welcome-header-subtitle">
              （严禁处理涉密信息）
            </span>
          </div>
          <DatetimeLabel />
          <div className="welcome-header-button">
            <Link
              to={
                auth.roles === "user"
                  ? "/workshop/announce/0"
                  : "/workshop/mproc/1"
              }
              className="ant-btn ant-btn-primary ant-btn-lg"
            >
              进入系统
            </Link>
          </div>
        </div>
      </div>
      <div className="welcome-content-container">
        <Row gutter={24}>
          <Col span={12}>
            <AnnouncementCard />
          </Col>
          <Col span={12}>
            <PublicationCard />
          </Col>
        </Row>

        {auth.roles === "admin" ? (
          <Row gutter={24}>
            <Col span={8}>
              <MessageCard
                label="市、州政府"
                title="市州政府"
                url="/workshop/mrece/市州政府"
              />
            </Col>
            <Col span={8}>
              <MessageCard title="省直部门" url="/workshop/mrece/省直部门" />
            </Col>
            <Col span={8}>
              <MessageCard
                title="省政府驻外办事处"
                url="/workshop/mrece/省政府驻外办事处"
              />
            </Col>
            <Col span={8}>
              <MessageCard
                title="中央在甘单位"
                url="/workshop/mrece/中央在甘单位"
              />
            </Col>
            <Col span={8}>
              <MessageCard title="信息直报点" url="/workshop/mrece/直报点" />
            </Col>
            <Col span={8}>
              <ExchangeCard />
            </Col>
          </Row>
        ) : auth.roles === "supervisor" || auth.roles === "senioruser" ? (
          <Row gutter={24}>
            <Col span={12}>
              <MessageCard
                label="县(市)、区政府"
                title="市州政府"
                url="/workshop/mrece/县区政府"
              />
            </Col>
            <Col span={12}>
              <MessageCard title="市直部门" url="/workshop/mrece/市直部门" />
            </Col>
            <Col span={12}>
              <ExchangeCard />
            </Col>
            <Col span={12}>
              <SubmitMessageCard
                title="已上报信息"
                url="/workshop/msubm/draft/finished"
              />
            </Col>
          </Row>
        ) : (
          <Row gutter={24}>
            <Col span={12}>
              <SubmitMessageCard
                title="已上报信息"
                url="/workshop/msubm/draft/finished"
              />
            </Col>
            <Col span={12}>
              <ExchangeCard />
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
}

export default WelcomeLayout;
